import React from 'react';
import radium from 'radium';

import CategoryList from './CategoryList.jsx';
import Toggler from './Toggler.jsx';
import { ThemeContext } from "../../../components/theme/Theme.jsx";
import { FocusTrap } from "focus-trap-react";

class CategoryDropDown extends React.Component {

	constructor(props, context) {
		super(props);

		// Styles
		this.style = {
			container: {
				// Needed so that seatingplan besides toggler stays clickable.
				height: '0px',
				left: '0',
				margin: 'auto',
				position: 'fixed',
				right: '0',
				width: '90%',
				zIndex: '2',
				'@media (min-width : 768px)': {
					width: '90%',
					margin: 'auto',
				},
				'@media (min-width : 992px)': {
					width: '80%',
					margin: 'auto',
				},
				'@media (min-width : 1200px)': {
					width: '70%',
					maxWidth: '1000px',
					margin: 'auto',
				},
			},
			open: {
				maxHeight: '30vh',
				'@media (min-width : 768px)': {
					borderTop: context.themeManager
						.value('catgory-dropdown', 'border-top-open', 'category-dropdown-border-top-open'),
				},
			},
			closed: {
				maxHeight: '0vh',
				display: 'none',
			},
			contentWrapper: {
				backgroundColor: context.themeManager.value('category-dropdown',
					'color', 'bg-color-dropdown-content'),
				paddingBottom: '0em',
				paddingTop: '0em',
				overflowY: 'hidden',
				// relatively fast transition as workaround for transition up to max-height
				// could possibly be optimized
				transition: 'max-height 0.35s ease-in-out',
				boxShadow: `0 2px 2px 0 rgba(0, 0, 0, 0.14),
							0 1px 5px 0 rgba(0, 0, 0, 0.12),
							0 3px 1px -2px rgba(0, 0, 0, 0.2)`,
				zIndex: '10',
			},
			contentContainer: {
				maxHeight: '30vh',
				overflowY: 'auto',
			},
		};

		this.state = {
			showContent: false,
		};

		this.toggleContent = this.toggleShowContent.bind(this);
	}

	toggleShowContent() {
		this.setState({showContent: !this.state.showContent});
	}

	render() {
		const openOrClosed = this.state.showContent ? this.style.open : this.style.closed;
		return (
			<>
				{this.state.showContent ?
					(<FocusTrap>
						<div style={this.style.container}>
							{this.state.showContent &&
								<div style={[this.style.contentWrapper, openOrClosed]}>
									<div style={this.style.contentContainer}>
										<CategoryList/>
									</div>
								</div>
							}
							<Toggler onClick={this.toggleContent} showContent={this.state.showContent}/>
						</div>
					</FocusTrap>) : (
						<div style={this.style.container}>
							{this.state.showContent &&
								<div style={[this.style.contentWrapper, openOrClosed]}>
									<div style={this.style.contentContainer}>
										<CategoryList/>
									</div>
								</div>
							}
							<Toggler onClick={this.toggleContent} showContent={this.state.showContent}/>
						</div>
					)
				}
			</>
		);
	}
}

CategoryDropDown.contextType = ThemeContext;

export default radium(CategoryDropDown);
